import { render } from "./add-template.vue?vue&type=template&id=12d87548&scoped=true"
import script from "./add-template.vue?vue&type=script&lang=js"
export * from "./add-template.vue?vue&type=script&lang=js"

import "./add-template.vue?vue&type=style&index=0&id=12d87548&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d87548"]])

export default __exports__